// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1uySC","unreadBadge":"styles_unreadBadge__1Ycp2","modalContent":"styles_modalContent__2nqXd","modal":"styles_modal__QUw5E"};